import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SalesOrderList from '../../components/Sales/SalesOrderList';
const SalesOrderListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SalesOrderList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default SalesOrderListPage;